import { LoginBonus } from '../../../../../services/exports/Interfaces';
import useMobileApp from '../../../../../hooks/mobile-app/useMobileApp';
import toast from 'react-hot-toast';
import { LoginBonusHandler } from '../../../types';
import { useTranslation } from 'react-i18next';
import HelperMethods from '../../../../../services/exports/HelperMethods';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../../store/types';
import { POINTS_PER_CURRENCY_UNIT } from '../../../../../hooks/cashback/useCashbackProgram';

const useMobileAppSignupBonus: LoginBonusHandler = () => {
  const { isMobileApp } = useMobileApp();
  const company = useSelector((state: StoreInterface) => state.initialData.company);
  const { t } = useTranslation(null, { keyPrefix: 'Features:Auth:LoginBonusByKind' });
  const handle = (bonus: LoginBonus): void => {
    if (!isMobileApp) {
      return;
    }

    if (!bonus.amount) {
      return;
    }

    const amount = HelperMethods.formatCurrency(bonus.amount / POINTS_PER_CURRENCY_UNIT, {
      currency: company?.currency,
      locale: company?.region?.number_locale,
    });

    toast.success(t(`${bonus.kind}.toast`, { amount }));
  };

  return handle;
};

export default useMobileAppSignupBonus;
